import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { CSVDataService } from '@app/export/CSVDataService';
import { StatisticsService } from '@app/services/Statistics/Statistics.service';
import { MenuItem } from 'primeng/api';

interface IYear {
  year: number;
}
interface NewInstitutionsPerYear {
  institutionName: string;
  institutionTypeId: number;
  institutionTypeName: string;
  institutionId: string;
  shortName: string;
  startDate: string;
}

@Component({
  selector: 'app-new-institutions-per-year',
  templateUrl: './new-institutions-per-year.component.html',
  styleUrls: ['./new-institutions-per-year.component.css']
})
export class NewInstitutionsPerYearComponent implements OnInit {

  currentyear = new Date().getFullYear();
  rangeValues: number[] = [1884, this.currentyear];
  years: IYear[] = [];
  filteredyears: IYear[] = [];
  toyears: IYear[] = [];
  fromyear;
  toyear;
  newInstitutionsList: NewInstitutionsPerYear[] = [];
  blahblag: string[] = [];
  list: any[] = [];
  details: any[] = [];
  items: MenuItem[];

  constructor(
    private statisticsService: StatisticsService,
    private datePipe: DatePipe) { }

  ngOnInit() {
    this.populateYears();
    this.setItems();
  }

  setItems() {
    this.items = [
      {
        label: 'Excel',
        icon: 'fa fa-file-excel',
        command: () => this.exportToCSV()
      }];
  }

  exportToCSV() {
    const firstrow = 'År;Brödraloge;Brödraläger;Rebeckaloge;Rebeckaläger';
    const datum = this.datePipe.transform(new Date(), 'yy-MM-dd');
    const filnamn = 'NyaInstitutionerPerÅr_' + datum;
    let data: any[] = [];
    this.list.forEach(x => {
      const row = {
        col1: x.year,
        col2: x.b.length,
        col3: x.bl.length,
        col4: x.r.length,
        col5: x.rl.length
      };
      data.push(row);
    });
    CSVDataService.exportToCsv(filnamn + '.csv', data, firstrow);
  }

  populateYears() {
    this.years = [];
    for (let i = this.rangeValues[1]; i > this.rangeValues[0] - 1; i--) {
      this.years.push({ year: i });
    }
  }

  clear() {
    this.newInstitutionsList = [];
    this.list = [];
    this.filteredyears = [];
    this.fromyear = null;
    this.toyear = null;
    this.populateYears();
    this.details = [];
  }

  search() {

    const statisticsInput = {
      fromYear: this.fromyear.year,
      toYear: this.toyear.year
    };

    this.statisticsService.GetNewInstitutionsAndCampsPerYearReport(statisticsInput).subscribe(resp => {
      this.newInstitutionsList = resp;
      const blodges: any[] = [];
      const rlodges: any[] = [];
      const bcamps: any[] = [];
      const rcamps: any[] = [];

      this.newInstitutionsList.forEach(i => {
        switch (i.institutionTypeId) {
          case 4: blodges.push(i);
            break;
          case 13: rlodges.push(i);
            break;
          case 5: bcamps.push(i);
            break;
          case 16: rcamps.push(i);
            break;
        }
      });

      for (let i = statisticsInput.toYear; i > statisticsInput.fromYear - 1; i--) {
        const blodgesperyear = [];
        blodges.forEach(x => {
          if ((x.startDate).startsWith(i)) {
            blodgesperyear.push(x);
          }
        });
        const bcampsperyear = [];
        bcamps.forEach(bcamp => {
          if ((bcamp.startDate).startsWith(i)) {
            bcampsperyear.push(bcamp);
          }
        });
        const rlodgesperyear = [];
        rlodges.forEach(x => {
          if ((x.startDate).startsWith(i)) {
            rlodgesperyear.push(x);
          }
        });
        const rcampsperyear = [];
        rcamps.forEach(x => {
          if ((x.startDate).startsWith(i)) {
            rcampsperyear.push(x);
          }
        });
        const test = {
          year: i,
          b: blodgesperyear,
          bl: bcampsperyear,
          r: rlodgesperyear,
          rl: rcampsperyear
        };
        this.list.push(test);
      }
    });
  }

  viewInstitutions(year, type) {
    this.details = [];
    const temp = this.list.filter(x => x.year === year);
    this.details = temp[0][type];
  }

  setToYears() {
    this.filteredyears = [];
    this.populateYears();
    this.filteredyears = this.years;
    this.filteredyears = this.filteredyears.filter(x => x.year >= this.fromyear.year);
  }
}
